import React from 'react';
import { useTranslation } from 'react-i18next';

interface GeoBlockScreenProps {
  countryName: string | null;
}

const GeoBlockScreen: React.FC<GeoBlockScreenProps> = ({ countryName }) => {
  const { t } = useTranslation();

  return (
    <div
      role="alert"
      aria-live="assertive"
      style={{
        position: 'fixed',
        top: 0,
        left: 0,
        right: 0,
        bottom: 0,
        zIndex: 99999,
        backgroundColor: 'rgba(10, 14, 20, 0.97)',
        backdropFilter: 'blur(10px)',
        display: 'flex',
        flexDirection: 'column',
        alignItems: 'center',
        justifyContent: 'center',
        color: '#fff',
        textAlign: 'center',
        padding: '32px 24px',
      }}
    >
      {/* Shield / block icon */}
      <div style={{ fontSize: 64, marginBottom: 24, lineHeight: 1 }}>🚫</div>

      <h2
        style={{
          fontWeight: 700,
          fontSize: '1.6rem',
          marginBottom: 12,
          color: '#fff',
        }}
      >
        {t('geo.block_title', { defaultValue: 'Service Not Available in Your Region' })}
      </h2>

      <p
        style={{
          fontSize: '1rem',
          color: '#b0bec5',
          maxWidth: 480,
          lineHeight: 1.7,
          marginBottom: 24,
        }}
      >
        {t('geo.block_body', {
          country: countryName ?? t('geo.your_region', { defaultValue: 'your region' }),
          defaultValue:
            'Access to Arm Financial is restricted for users in {{country}}.',
        })}
      </p>



      <div
        style={{
          display: 'inline-block',
          padding: '8px 20px',
          borderRadius: 8,
          background: 'rgba(239, 68, 68, 0.15)',
          border: '1px solid rgba(239, 68, 68, 0.35)',
          color: '#fca5a5',
          fontSize: '0.82rem',
          maxWidth: 460,
          lineHeight: 1.5,
        }}
      >
        {t('geo.block_legal', {
          defaultValue:
            'If you believe this is a mistake or you are accessing via VPN/proxy, please contact our support team for assistance.',
        })}
      </div>
    </div>
  );
};

export default GeoBlockScreen;
